// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DZHFN","selected":"styles_selected__2yuz9"};